import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';

export const handleUpdateUserResultData = async (
  userId: string,
  userName: string,
  userIconUrl: string | null,
): Promise<void> => {
  const updateUserResultData = httpsCallable(functions, 'updateUserResultData');
  const result = (await updateUserResultData({
    userId,
    userName,
    userIconUrl,
  })) as { data: { success: boolean; error?: string } };

  if (!result.data?.success || result.data?.error) {
    throw new Error(result.data?.error || 'resultの更新に失敗しました');
  }
};
